import { SVGProps, Ref, forwardRef } from 'react';

export const GoogleSolidSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="m14.918 6.921-.072-.3h-6.64v2.757h3.967c-.412 1.92-2.323 2.929-3.885 2.929-1.136 0-2.333-.468-3.126-1.222a4.34 4.34 0 0 1-1.331-3.09c0-1.161.532-2.323 1.307-3.087.772-.76 1.942-1.191 3.106-1.191 1.331 0 2.285.693 2.642 1.01l1.997-1.95C12.296 2.272 10.687 1 8.178 1c-1.935 0-3.791.727-5.147 2.053C1.693 4.36 1 6.248 1 7.998s.655 3.548 1.952 4.865C4.34 14.266 6.302 15 8.322 15c1.84 0 3.583-.707 4.825-1.99C14.37 11.749 15 10.002 15 8.17c0-.77-.079-1.229-.082-1.249"
                fill="currentColor"
            />
        </g>
    </svg>
));
GoogleSolidSize16Glyph.displayName = 'GoogleSolidSize16Glyph';
